import React, { useState, useEffect } from 'react';
import { translate, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { func, string, bool } from 'prop-types';

import { Button } from '@snapask/common-components';

import { getSignupEmail } from '@dragonfruit/redux/signup';
import { resendEmail } from '@dragonfruit/redux/sendEmail';

import EmailVerificationInfoImage from './images/img_email_verification_info.svg';
import styles from './EmailVerificationInfo.scss';
const cx = require('classnames/bind').bind(styles);

const COUNT_DOWN_SECOND = 60;

function EmailVerificationInfo({
  email,
  isCurrentStage,
  returnToAuthTypeSelection,
  resendEmail,
  t,
}) {
  const [seconds, setSeconds] = useState(COUNT_DOWN_SECOND);

  const canNotSentCodeAgain = seconds > 0;

  const sendCodeAgain = () => {
    resendEmail();
    setSeconds(COUNT_DOWN_SECOND);
  };

  useEffect(() => {
    if (isCurrentStage) {
      setSeconds(COUNT_DOWN_SECOND);
    }
  }, [isCurrentStage]);

  useEffect(() => {
    // this component will mount on user into signup page
    // but the count should start when user into this stage
    if (!isCurrentStage) {
      return;
    }

    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      // eslint-disable-next-line consistent-return
      return () => clearTimeout(timer);
    }
  }, [isCurrentStage, seconds]);

  return (
    <div className={styles.root}>
      <h3>{t('studentSignup.checkEmail.title')}</h3>
      <p className={styles.description}>
        <Trans i18nKey="studentSignup.checkEmail.descr">
          we sent a verify email to
          <strong>{{ email }}</strong>, tap the verify link in the email and you
          are good to go!
        </Trans>
      </p>
      <p>{t('studentSignup.checkEmail.notReceive')}</p>
      <Button
        className={cx(styles.button)}
        ghost
        disabled={canNotSentCodeAgain}
        onClick={sendCodeAgain}
        text={`${t('studentSignup.checkEmail.sendAgain')} ${
          canNotSentCodeAgain ? `( ${seconds} )` : ''
        }`}
      />
      <p className={styles.help}>
        <span>{t('studentSignup.checkEmail.stillGotTrouble')}</span>
        <Button
          className={cx(styles.button, styles.changeEmail)}
          ghost
          onClick={returnToAuthTypeSelection}
          text={t('studentSignup.checkEmail.tryAnotherEmail')}
        />
      </p>
      <img
        className={styles.image}
        src={EmailVerificationInfoImage}
        alt="Email Verification Info"
      />
    </div>
  );
}

EmailVerificationInfo.propTypes = {
  email: string.isRequired,
  resendEmail: func.isRequired,
  returnToAuthTypeSelection: func.isRequired,
  t: func.isRequired,
  isCurrentStage: bool,
};

EmailVerificationInfo.defaultProps = {
  isCurrentStage: true,
};

export default translate(['studentSignup'])(
  connect(
    state => ({
      email: getSignupEmail(state),
    }),
    {
      resendEmail,
    }
  )(EmailVerificationInfo)
);



// WEBPACK FOOTER //
// ./app/components/EmailVerificationInfo/EmailVerificationInfo.jsx